// Multivariate Dependencies
import React from 'react';
// Components
import Icon from '../Icons/Icon';
import { ContainerLegacy } from '../styles/Containers/ContainerLegacy';
/**
 * A button component for the toolbar (will be replaced by SmallButton from react-ui)
 *
 * @deprecated Do not use legacy components anymore.
 * @param {ToolbarButtonProps} props { icon, buttonText, onClick, disabled, highlighted, showText = true }
 * @returns {Element} Button component
 */
export var ToolbarButton = function (_a) {
    // Todo: use themes and replace this with SmallButton
    // from ezyevt-react-ui once built. https://ezyvet.atlassian.net/browse/EZ-53957
    var icon = _a.icon, _b = _a.buttonText, buttonText = _b === void 0 ? '' : _b, onClick = _a.onClick, disabled = _a.disabled, highlighted = _a.highlighted;
    // Default style values
    var pointerEvents = 'auto';
    var backgroundColor = '#FFF';
    var color = '#000';
    var hoverEffects = "background: linear-gradient(to bottom, #FFF 5%, #CCC 100%); \n                      box-shadow: 1px 2px 1px 1px #00000033";
    var activeEffects = "background: linear-gradient(to bottom, #CCC 5%, #FFF 100%);\n                       position: relative; \n                       top:2px; \n                       box-shadow:none";
    if (highlighted) {
        backgroundColor = '#FAD44B';
        hoverEffects = 'box-shadow: 0px 1px 3px 1px #00000033';
        activeEffects = "position: relative; \n                     top:1px; \n                     box-shadow:none";
    }
    if (disabled) {
        backgroundColor = '#cccccc';
        pointerEvents = 'none';
        color = '#838383';
    }
    return (React.createElement(ContainerLegacy, { as: 'div', onClick: onClick, border: '1px solid #838383', borderRadius: '6px', padding: '0 5px', height: '24px', margin: '5px', display: 'flex', alignItems: 'center', fontSize: '12px', color: color, backgroundColor: backgroundColor, hoverEffects: hoverEffects, activeEffects: activeEffects, pointerEvents: pointerEvents },
        icon !== undefined && (React.createElement(ContainerLegacy, { margin: '4px 3px 0 0' },
            React.createElement(Icon, { icon: icon }))),
        buttonText && React.createElement("div", null, buttonText.toUpperCase())));
};
//# sourceMappingURL=ToolbarButton.js.map